<ng-container *ngIf="$items | async as items">
  <yo-link-list
    [items]="$items | async"
    layout="carousel"
    [layout]="getLayoutType(moduleData.layoutType)"
    [density]="getLinkCardDensity(moduleData.density)"
    [title]="moduleData.heading"
    [titleVariant]="moduleData.titleVariant"
    [isCentered]="moduleData.isCentered ?? false"
    [isLoading]="isLoading"
  ></yo-link-list>
</ng-container>
